function Search(container)
{
	container.addEventListener("input", ({ target }) => {
			
		const isSearchInput =
			target.nodeName === "INPUT" &&
			target.type === "search";

		if (isSearchInput) {
			var searchValue = target.value.toLowerCase();
			var checkboxes = container.querySelectorAll(`.inline-checkbox`);
			var parents = container.querySelectorAll(`.item-parent`);
			checkboxes.forEach(function(checkbox) {
				var term = checkbox.getAttribute('data-term').toLowerCase();
				// check whether the input field is checked
				var input = checkbox.querySelector('input[type="checkbox"]')
				var checked = input ? input.checked : false;
				if (term.includes(searchValue) || checked) {
					checkbox.style.display = 'block';
					// if the parent is hidden, show it
					var parent = checkbox.closest('.item-parent');
					if (parent) {
						parent.style.display = 'flex';
						parent.querySelector('.inline-checkbox').style.display = 'block';
						var subfilter = checkbox.closest('.item-parent').querySelector('.sub-filters');
						// if subfilter has a hidden attribute, remove it
						if (subfilter) {
							subfilter.removeAttribute('hidden');
						}
					}
				} else {
					checkbox.style.display = 'none';
				}
			});

			parents.forEach(function(parent) {
				var checkboxes = parent.querySelectorAll('.inline-checkbox');
				var visibleCheckboxes = parent.querySelectorAll('.inline-checkbox[style="display: block;"]');
				if (visibleCheckboxes.length > 0) {
					parent.style.display = 'flex';
				} else {
					parent.style.display = 'none';
				}
			});
		}
	});
}

export default Search;